import type { ReactNode } from 'react';

export const symbol_airline_seat_recline_normal: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M590-171H300q-24.75 0-42.37-17.63Q240-206.25 240-231v-431q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v431h290q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5ZM438-718q-34 0-57.5-23.5T357-799q0-34 23.5-57.5T438-880q34 0 57.5 23.5T519-799q0 34-23.5 57.5T438-718Zm222 608v-161H415q-30.94 0-52.97-21.74Q340-314.48 340-345v-228q0-40.74 28.39-68.87Q396.77-670 437.89-670q41.11 0 69.61 28.13T536-573v202h109q30.94 0 52.97 21.74Q720-327.52 720-297v187q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q660-97.25 660-110Z"
		/>
	</svg>
);
